<template>
  <v-card elevation="0">
    <v-card-title class="justify-center" style="background-color: #b9c2d0; color: #334155">
      <v-icon left color="#334155">{{ icone }}</v-icon>
      {{ descricao }}
    </v-card-title>

    <v-card-text>
      <v-row class="mt-5">
        <v-text-field label="Pesquisar" v-model="pesquisa" class="ml-5 mr-5" outlined dense />

        <v-tooltip v-for="botao in botoes" :key="botao.icone" bottom>
          <template v-slot:activator="{ on }">
            <v-btn @click="botao.funcao" v-on="on" dark :color="botao.cor" class="mr-5">
              <v-icon>{{ botao.icone }}</v-icon>
              {{ botao.texto }}
            </v-btn>
          </template>
          <span>{{ botao.tooltip }}</span>
        </v-tooltip>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import _ from "lodash";

export default {
  props: {
    descricao: String,
    icone: String,
    pesquisar: Function,
    botoes: Array,
  },
  data() {
    return {
      pesquisa: null,
    };
  },

  watch: {
    pesquisa: _.debounce(function () {
      this.pesquisar(this.pesquisa);
    }, 300),
  },
};
</script>
